import React, {Component} from 'react'
import { Link } from "react-router-dom"
import NavItems from "./NavItems"
import Drawer from "./Drawer"
import Social from "../Social/Social"
import logo from "../../assets/images/ecfoundation1.png"
const classes = require('./Header.module.scss')

class Header extends Component {
  render() {
    return (
      <header className={[classes.Header, classes[this.props.HeaderType]].join(' ')}>
        <div className={[classes.headerItem, classes.mobileDonate].join(' ')}>
          <button type="button" data-uk-toggle="target: #modalDonate" className={classes.modalLink}>Donate Now</button>
        </div>

        <div className={[classes.headerItem, classes.topRow].join(' ')}>
          <div className={[classes.topWrap, classes.insideN, classes.flexGroup].join(' ')}>
            <div className={[classes.topItem, classes.end, classes.modalGroup].join(' ')}>
              <button type="button" data-uk-toggle="target: #modalDonate" className={classes.modalLink}>Donate Now</button>
            </div>
            <div className={[classes.topItem, classes.logoBlk].join(' ')}>
              <Link to="/" className={[classes.logoMain].join(' ')}><img src={logo} alt="Emerald Coast Foundation Logo" className={[classes.imgResponsive, classes.hdLogo].join(' ')} /></Link>
            </div>
            <div className={[classes.topItem, classes.end, classes.socialLinks].join(' ')}>
              <Social where="header" />
            </div>
            <div className={[classes.topItem, classes.end, classes.mobNav].join(' ')}><Drawer /></div>
          </div>
        </div>

        <div className={[classes.headerItem, classes.navRow].join(' ')}>
          <div className={[classes.navWrap, classes.inside].join(' ')}>          
            <nav className={[classes.navMm, "uk-navbar-container"].join(' ')} data-uk-navbar>
              <NavItems navClass="navBarCustom" addClass="uk-navbar-nav" />
            </nav>        
          </div>
        </div>
      </header>
    )
  }
}

export default Header


